// @flow

import type { State } from "@store/reducers";
import type { Client } from "@modules/context/types";

export const getClientContext = (state: State): Client | null => {
  return state.context.client;
};
